import presence from './presence/';

export default [
  { name: 'presence', actions: presence }
];